import Vue from 'vue';
import Vuex from 'vuex';

import language from './modules/language';
import auth from './modules/auth';
import chat from './modules/chat';
import preference from './modules/preference';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        language,
        chat,
        auth,
        preference,
    },
    strict: debug,
});
